import { render, staticRenderFns } from "./InFormDetail.vue?vue&type=template&id=42969d0e&scoped=true&"
import script from "./InFormDetail.vue?vue&type=script&lang=js&"
export * from "./InFormDetail.vue?vue&type=script&lang=js&"
import style0 from "./InFormDetail.vue?vue&type=style&index=0&id=42969d0e&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42969d0e",
  null
  
)

export default component.exports